<div *ngIf="block && block.aspetto === 'Riga'" class="container-divider-riga"></div>
<div *ngIf="block && block.aspetto === 'Vuoto'" class="container-divider-vuoto"></div>